import React from 'react';
import { motion } from 'framer-motion';
interface BookMockupProps {
  title: string;
  subtitle?: string;
  color?: 'navy' | 'mint' | 'white';
  size?: 'sm' | 'md' | 'lg';
  delay?: number;
  image?: string;
}
export function BookMockup({
  title,
  subtitle,
  color = 'navy',
  size = 'md',
  delay = 0,
  image
}: BookMockupProps) {
  const sizeClasses = {
    sm: 'w-32 h-44 text-xs',
    md: 'w-48 h-64 text-sm',
    lg: 'w-64 h-80 text-base'
  };
  const colorClasses = {
    navy: 'bg-navy text-white border-navy-dark',
    mint: 'bg-mint text-navy border-mint-dark',
    white: 'bg-white text-navy border-gray-200'
  };
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.6,
    delay
  }} className={`relative ${sizeClasses[size]} rounded-r-md rounded-l-sm shadow-book transform transition-transform hover:-translate-y-2 duration-300 flex flex-col justify-center items-center text-center border-l-8 ${image ? 'overflow-hidden p-0' : 'p-4'} ${colorClasses[color]}`} data-id="element-16">
      <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-r from-black/10 to-transparent pointer-events-none rounded-r-md z-20" data-id="element-17" />
      <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-b from-white/10 to-transparent pointer-events-none rounded-r-md z-20" data-id="element-18" />

      {image ? <img src={image} alt={title} className="absolute inset-0 w-full h-full object-cover z-10" data-id="element-19" /> : <div className="z-10 flex flex-col items-center justify-center h-full w-full border border-white/20 p-2 rounded-sm" data-id="element-20">
          <h3 className="font-playfair font-bold leading-tight mb-2" data-id="element-21">
            {title}
          </h3>
          {subtitle && <p className="opacity-80 text-[0.8em] uppercase tracking-wider" data-id="element-22">
              {subtitle}
            </p>}
        </div>}

      {/* Spine effect */}
      <div className="absolute left-0 top-0 bottom-0 w-1 bg-white/20 z-30" data-id="element-23" />
      <div className="absolute left-1 top-0 bottom-0 w-[1px] bg-black/10 z-30" data-id="element-24" />
    </motion.div>;
}